//frontend/src/components/STT.jsx
import React, { useEffect, useRef, useState } from 'react';
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';

const STT = (props) => {
  const [transcript, setTranscript] = useState(""); 
  const [isListening, setIsListening] = useState(false);
  const recognitionRef = useRef(null);
  
  useEffect(() => {
    if (!('webkitSpeechRecognition' in window)) {
      console.error("Web Speech is not supported by your browser");
      return;
    }

    recognitionRef.current = new window.webkitSpeechRecognition();
    const recognition = recognitionRef.current;
    recognition.interimResults = props.interimResults || true;
    recognition.lang = props.lang || "en-US";
    recognition.continuous = props.continuous || false;
    
    if ("webkitSpeechGrammarList" in window) {
      const grammar = "";
      const SpeechRecognitionList = new window.webkitSpeechGrammarList();
      SpeechRecognitionList.addFromString(grammar, 1);
      recognition.grammar = SpeechRecognitionList;
    }

    recognition.onresult = (event) => {
      let text = "";
      for (let i = 0; i < event.results.length; i++) {
        text += event.results[i][0].transcript;
      }
      setTranscript(text);
    };

    recognition.onerror = (event) => {
      console.error("Speech Recognition Error:", event.error);
    };

    recognition.onend = () => {
      setIsListening(false);
      setTranscript("");
    };

    return () => {
      recognition.stop();
    };
  }, [props.continuous, props.interimResults, props.lang]);

  const startListening = () => {
    if (recognitionRef.current && !isListening) {
      recognitionRef.current.start();
      setIsListening(true);
    }
  };

  const stopListening = () => {
    if (recognitionRef.current && isListening) {
      recognitionRef.current.stop();
      setIsListening(false);
    }
  };

  return (
    <div>
      {isListening && <p>Listening...</p>}
      <p>{transcript}</p>
      <button onClick={startListening}>Start Listening</button>
      <button onClick={stopListening}>Stop Listening</button>
    </div>
  );
};

export default STT;
